import { ComponentsIconsStyle, IconName } from './icons.model';

export type TargetType = '_self' | '_blank' | '_parent' | '_top';
export type NavItemType = 'content' | 'category' | 'product' | 'copyright' | 'login' | 'privacy-settings' | 'registration' | 'terms-of-service';
export type NavigationTrackingEventName = 'cepPrimaryNavigation';
export type NavbarNavigationName = 'main' | 'offers';

export interface NavItemBaseModel {
  type?: NavItemType;
  id?: string | number;
  name?: string;
  label?: string;
  active?: boolean;
  selected?: boolean;
  expanded?: boolean;
  indeterminate?: boolean;
}

export interface NavItemNodeModel extends NavItemBaseModel {
  children?: NavItemNodeModel[];
  parent?: NavItemNodeModel;
  description?: string;
  target?: TargetType;
  url?: string;
  queryParams?: Record<string, string>;
  categoryBannerContentId?: string;
  badgeCount?: string | number;
  icon?: {
    family: ComponentsIconsStyle;
    name: IconName;
  };
  image?: {
    src: string;
    alt: string;
  };
}

export interface NavItemModel extends Readonly<NavItemNodeModel> {
  readonly parent?: NavItemModel;
  children?: NavItemModel[];
}

export interface NavNodeModel extends NavItemNodeModel {
  title?: string;
  gtmEvent?: NavigationTrackingEventName;
}

export interface NavModel extends Readonly<NavNodeModel> {
  children?: NavItemModel[];
}

export interface MainContentNavigationModel {
  offerItem: NavItemModel | undefined;
  brandItem: NavItemModel | undefined;
}

export const buildNavigationTree = <T extends NavItemNodeModel>(item: T, parent?: NavItemModel): NavItemModel => {
  const result: NavItemNodeModel = { ...item, parent };

  result.children = item.children?.map(child => buildNavigationTree(child, result));

  return result;
};
